/**
 * Steps Page — Volcano Step Library browser.
 * Wraps the existing StepLibraryView in the standard Agent Manager shell.
 */

import { useNavigate, useLocation } from 'react-router-dom';
import {
  Bot,
  Sparkles,
  Activity,
  Network,
  Blocks,
} from 'lucide-react';
import StepLibraryView from '../volcano/components/steps/StepLibraryView';

export default function StepsPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab = 'steps';

  // Support deep-linking to a specific step via ?stepId=xxx
  const params = new URLSearchParams(location.search);
  const stepId = params.get('stepId');

  return (
    <div className="h-full flex flex-col">
      {/* ── Top Navigation Bar ─────────────────────────────────── */}
      <div className="border-b bg-white px-6 pt-4 pb-0">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 rounded-lg bg-violet-600 flex items-center justify-center">
            <Bot className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-gray-900">Agent Manager</h1>
            <p className="text-xs text-gray-500">Build, run, and observe your agentic workflows</p>
          </div>
        </div>

        <nav className="flex gap-1 -mb-px">
          {[
            { id: 'hub', label: 'Agents', icon: Bot, path: '/agents/hub' },
            { id: 'create', label: 'Create', icon: Sparkles, path: '/agents/create' },
            { id: 'observe', label: 'Observe', icon: Activity, path: '/agents/observe' },
            { id: 'ecosystem', label: 'Ecosystem', icon: Network, path: '/agents/ecosystem' },
            { id: 'steps', label: 'Steps', icon: Blocks, path: '/agents/steps' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              className={`
                flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors
                ${activeTab === tab.id
                  ? 'border-violet-600 text-violet-700'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              <tab.icon className="w-4 h-4" />
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* ── Content ────────────────────────────────────────────── */}
      <div className="flex-1 overflow-auto bg-gray-50">
        <StepLibraryView initialSelectedStepId={stepId} />
      </div>
    </div>
  );
}
